import React, {useEffect} from 'react'
import {Route, Switch, withRouter} from 'react-router'
import WarehouseShipmentForm from './WarehouseShipmentForm'
import WarehouseProducts from './WarehouseProducts'
import {RootState} from "../../reducers";
import {bindActionCreators, Dispatch} from "redux";
import * as actions from "../../actions/generalActions";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import Archive from "../Archive/Archive";
import Page404 from "../Page404";
import InnerStock from "./InnerStock";
import WarehouseMainPage from "./WarehouseMainPage";

interface Props {
    actions: any
}

const Warehouse = (props: Props) => {

    useEffect(()=>{
        props.actions.getUserPermissionsAndResponsibilities()
    }, [])

    return (
        <div className="transport inside-container">
            <Switch>
                <Route exact path="/dashboard/warehouse" component={WarehouseMainPage} />
                <Route exact path="/dashboard/warehouse/inner-stock" component={InnerStock} />
                <Route path="/dashboard/warehouse/create/:clientId?/:projectId?" component={WarehouseShipmentForm}/>
                <Route path="/dashboard/warehouse/purchased-materials" component={WarehouseProducts}/>
                <Route path="/dashboard/warehouse/archive/:moduleName?" component={Archive} />
                <Route render={()=><Page404/>}/>
            </Switch>
        </div>
    )
}
function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Warehouse as any)));